<template>
    <v-app id="inspire">
      <app-header>
        <template #companyName>Establecimiento San Cayetano</template>
      </app-header>
      <v-main>
        <app-side-menu/>
        <v-container fluid class="app-content">
          <v-snackbar location="top" :color="getSnackBarStatus.color" :model-value="getSnackBarStatus.actived">
            {{getSnackBarStatus.message}}
          </v-snackbar>
          <esc-alert-dialog/>
          <router-view></router-view>
        </v-container>
      </v-main>
      <app-footer/>
    </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import AppHeader from './components/Layout/Header.vue'
import AppSideBar from './components/Layout/SideBar.vue'
import AppFooter from './components/Layout/Footer.vue'
import AlertDialog from './components/Common/AlertDialog'

export default {
  name: 'Layout',
  components: {
    'app-header': AppHeader,
    'app-side-menu': AppSideBar,
    'app-footer': AppFooter,
    'esc-alert-dialog': AlertDialog
  },

  props: {
    source: String
  },

  computed: {
    ...mapGetters(['getSnackBarStatus'])
  }
}
</script>
<style/>
